import Media from './media';
import Richtext from './richtext';

export default class AccordionConfig {
  closedColor?: string;
  openedColor?: string;
  icon?: Media;
  internalName?: string;
  richText?: Richtext;
  openedBackgroundColor?: string;
  analyticsAttributes: any;

  constructor(props: any) {
    this.closedColor = props.closedColor;
    this.openedColor = props.openedColor;
    this.internalName = props.internalName || '';
    this.icon = props.icon ? new Media(props.icon) : undefined;
    this.openedBackgroundColor = props.openedBackgroundColor;
    this.richText = props.content ? new Richtext(props.content) : undefined;
    this.analyticsAttributes = props.analyticsAttributes;
  }
}
